/*
 * 申请冻息
 *
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { ApplyFrozenInterestReq} from "@/pbjs/xcommon/collection_pb";
import InnerRequest from "./request";
export interface Options {
    OrderId?: string;
}
export function setApplyFrozenInterestReq(arg: Options) {
    let request: any = new ApplyFrozenInterestReq();
    request.setOrderid(arg.OrderId);
    return request;
}
export const applyFrozenInterestRequest = new InnerRequest(
    collectionServiceClient,
    collectionServiceClient.applyFrozenInterest
);